import PedidoController from "@/shared/controllers/pedido/PedidoController";
import PedidoObservacoesViewModel from "@/shared/view-models/PedidoObservacoesViewModel";
import Tools from "@/shared/services/tools";
import { defineComponent } from "vue";

const name = 'ObservacoesPedidosExpedidoFaturado'
export default defineComponent({
  name,


  components: {},


  props: {},


  mounted() {
    this.pedidoId = this.$route.params.id
    this.numeroParcela = this.$route.params.numeroParcela
    this.getDetalhesObservacoes()
    this.getObservacoes()
  },


  updated() { },


  data() {
    return {
      pedidoId: null,
      numeroParcela: null,
      observacoesInfoArray: [],
      observacoesPedidoAndamento: new PedidoObservacoesViewModel(),
    }
  },

  methods: {

    formataDecimal(valor){
      return Tools.valorDecimalFormatado(valor)
    },

    formataMonetario(valor){ 
      return Tools.valorMonetario4Digitos(valor)
    },
    voltar() {
      this.$router.back()
    },


    getDetalhesObservacoes() {
      PedidoController.GetDetalhesObservacoesPedidoAndamento(this.pedidoId, this.numeroParcela).requisicao
        .then((res => {
          Tools.objectCustomAssign(this.observacoesPedidoAndamento, Tools.captalizeKeys(res.data.data))
        }))
        .catch(() => {
        })
    },


    getObservacoes() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetObservacoesDoPedido/${this.$route.params.id}/${this.numeroParcela}`,
      })
        .then((response) => {
          this.observacoesInfoArray = response.data.data;
        })
        .catch(() => {
        });
    },
  },

  computed: {},

});